import { render } from "./ProcessoAssuntoArvoreComponent.vue?vue&type=template&id=e42d75f0&scoped=true"
import script from "./ProcessoAssuntoArvoreComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoAssuntoArvoreComponent.vue?vue&type=script&lang=js"

import "./ProcessoAssuntoArvoreComponent.vue?vue&type=style&index=0&id=e42d75f0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e42d75f0"]])

export default __exports__